export default __webpack_public_path__ + "static/teams-salesTeam-fd2c7fb0d740e0a27f1461f88baa4e01.mp4";